import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { serializeConversation } from '../../utils/conversationUtils';

/**
 * useSelectedConversation - Hook compartido para obtener la conversación seleccionada (OPTIMIZADO)
 *
 * PROPÓSITO:
 * - Hook reutilizable para obtener la conversación actualmente seleccionada
 * - Optimizado para uso en múltiples componentes y módulos
 * - Serialización consistente usando conversationUtils
 * - Memoización optimizada usando useMemo de React
 */
export default function useSelectedConversation() {
  const conversations = useSelector((state) => state.conversationsReducer.data);
  const selectedId = useSelector((state) => state.conversationsReducer.selectedConversationId);
  const externalConversation = useSelector((state) => state.conversationsReducer.externalConversation);
  const currentRetailerUser = useSelector((state) => state.mainReducer.currentRetailerUser);
  const inboxAgentsReducer = useSelector((state) => state.inboxAgentsReducer);

  // Conversación serializada memoizada
  const conversation = useMemo(() => {
    // Buscar solo la conversación seleccionada
    const rawConversation = conversations.find((conv) => String(conv.id) === String(selectedId))
      || (externalConversation && String(externalConversation.id) === String(selectedId)
        ? externalConversation
        : null);
    if (!rawConversation) return null;
    return serializeConversation(rawConversation, currentRetailerUser, inboxAgentsReducer);
  }, [
    selectedId,
    conversations,
    externalConversation,
    currentRetailerUser,
    inboxAgentsReducer
  ]);

  return conversation;
}
